import { cityData } from "@/data/cityData";

const cityImageOverrides: Record<string, string> = {
  amsterdam: "/images/cities/amsterdam.jpg",
  arnhem: "/images/cities/arnhem.jpg",
  breda: "/images/cities/breda.jpg",
  "den-haag": "/images/cities/denhaag.jpg",
  eindhoven: "/images/cities/eindhoven.jpg",
  groningen: "/images/cities/groningen.jpg",
  rotterdam: "/images/cities/rotterdam.jpg",
  tilburg: "/images/cities/tilburg.jpg",
  utrecht: "/images/cities/utrecht.jpg",
};

const provinceImageMap: Record<string, string> = {
  Drenthe: "/images/cities/provinces/drenthe.jpg",
  Flevoland: "/images/cities/provinces/flevoland.jpg",
  Friesland: "/images/cities/provinces/friesland.jpg",
  Gelderland: "/images/cities/provinces/gelderland.jpg",
  Groningen: "/images/cities/provinces/groningen.jpg",
  Limburg: "/images/cities/provinces/limburg.jpg",
  "Noord-Brabant": "/images/cities/provinces/noord-brabant.jpg",
  "Noord-Holland": "/images/cities/provinces/noord-holland.jpg",
  Overijssel: "/images/cities/provinces/overijssel.jpg",
  Utrecht: "/images/cities/provinces/utrecht.jpg",
  Zeeland: "/images/cities/provinces/zeeland.jpg",
  "Zuid-Holland": "/images/cities/provinces/zuid-holland.jpg",
};

const slugifyCityValue = (value: string) =>
  value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const getCityImage = (citySlug?: string | null, cityName?: string | null) => {
  const normalizedSlug = citySlug
    ? slugifyCityValue(citySlug)
    : cityName
      ? slugifyCityValue(cityName)
      : "";

  if (!normalizedSlug) return cityImageOverrides.amsterdam;
  if (cityImageOverrides[normalizedSlug]) return cityImageOverrides[normalizedSlug];

  const province = cityData[normalizedSlug]?.province;
  if (province && provinceImageMap[province]) return provinceImageMap[province];

  return cityImageOverrides.amsterdam;
};